/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class MultiPanelService implements OnDestroy {
	private idCounter = 0;

	private collapseSubject = new BehaviorSubject<Map<string, boolean>>(new Map());
	public collapse$ = this.collapseSubject.asObservable();

	public collapse(panelId: string, open: boolean) {
		//going to claim it's _more_ future-proof to not force only existing ids
		const map = this.collapseSubject.getValue();
		map.set(panelId, open);
		this.collapseSubject.next(map);
	}

	public toggleCollapse(panelId: string) {
		const map = this.collapseSubject.getValue();
		this.collapse(panelId, !map.get(panelId));
	}

	public isCollapsed$(panelId: string) {
		return this.collapse$.pipe(map((panels) => !!panels.get(panelId)));
	}

	public requestNewId() {
		const id = `multi-panel-${this.idCounter++}`; //ripped off from material
		this.collapse(id, false); //undecided if emitting here is a good idea
		return id;
	}

	public ngOnDestroy() {
		this.collapseSubject.complete();
	}
}
